import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { colorsV2 } from '../../../figma/colors-v2';
import { Typography } from '../../../figma/DesignSystemV2/Typography';

const SelectionNumber = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 1;
  width: 32px;
  min-width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background-color: ${colorsV2.gray10};
  border: 1px dashed ${colorsV2.gray60};
  border-radius: 50%;
  color: transparent;
  cursor: pointer;
  user-select: none;
`;

const CardContent = styled.div`
  height: 100%;
`;

const Container = styled.div`
  position: relative;
  border-width: 2px;
  border-style: solid;
  border-color: transparent;
  border-radius: 16px;
  z-index: 1001;

  &.selected {
    border-color: ${colorsV2.primary100};

    ${SelectionNumber} {
      background-color: ${colorsV2.red100};
      border-color: transparent;
      color: ${colorsV2.white100};
    }
  }
`;

interface TrendingSelectionCardProps extends React.HTMLAttributes<HTMLDivElement> {
  selectionNumber?: number;
  onSelected?: (selected?: boolean) => void;
  selected?: boolean;
}

export const TrendingSelectionCard = (props: TrendingSelectionCardProps) => {
  const { children, className, selectionNumber = 0, onSelected, selected = false } = props;

  return (
    <Container className={cl(className, { selected })} onClick={() => onSelected(selected)}>
      <CardContent>{children}</CardContent>
      <SelectionNumber>
        <Typography.Text variant="semi-bold/12">{selectionNumber}</Typography.Text>
      </SelectionNumber>
    </Container>
  );
};
